module.exports = __webpack_public_path__ + "static/img/www.0840bbea.png";